import {
  CompositeFilterDescriptor,
  FilterDescriptor,
} from "@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface";

export type relationMatcherProps = { relation: string; regex: RegExp }[];

export function buildRelationFilter(matchingOptions: relationMatcherProps, inputValue: string) {
  const searchValues = inputValue.split(" ");
  const buildFilters: FilterDescriptor[] = [];

  searchValues.forEach((searchValue) => {
    matchingOptions.forEach((matcher) => {
      const matches = searchValue.match(matcher.regex);
      if (matches && matches.length > 0) {
        buildFilters.push({
          field: matcher.relation,
          operator: "eq",
          value: searchValue,
        });
      }
    });
  });

  const filter: CompositeFilterDescriptor = {
    logic: "or",
    filters: buildFilters,
  };
  return filter;
}
